module.exports = __webpack_public_path__ + "igor-stupka.jpg?c58940eb9440a2246fae59cb37c425da";


//////////////////
// WEBPACK FOOTER
// ./src/img/igor-stupka.jpg
// module id = 25
// module chunks = 0